module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Conversation */
(function(fox) {
	fox.registerWidget('SitePage_Conversation', {}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/conversation.js
// module id = 914
// module chunks = 4